export default __webpack_public_path__ + "static/media/main_section23.46bb69a4.jpg";